<app-search></app-search>
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Administrar grupos</h1>
    </div>
    <br />

    <div class="card-header">
      <button class="primary-button" appPermision="/groups+c" (click)="openForm(null)">
        <span class="button-content"> <mat-icon>add_circle</mat-icon> Agregar nuevo </span>
      </button>
      <button class="secondary-button" appPermision="/groups+c" (click)="generatePermisions()">
        <span class="button-content">
          <mat-icon>auto_awesome_motion_24</mat-icon>Generar permisos
        </span>
      </button>
    </div>
    <br />
    <div class="table-scroll-wrapper">
      <section class="table-container mat-elevation-z2" tabindex="0">
        <div class="table-adjustable">
          <table
            mat-table
            [dataSource]="
              (asyncGrupos | async) ?? []
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: limit,
                      currentPage: page,
                      totalItems: total,
                    }
            "
          >
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let group">
                <div class="action-buttons">
                  <a
                    title="Editar"
                    class="icon-button"
                    appPermision="/groups+u"
                    (click)="openForm(group)"
                  >
                    <span class="material-symbols-outlined"><mat-icon>edit</mat-icon></span>
                  </a>
                  <a
                    title="Revocar permisos"
                    class="icon-button"
                    appPermision="/groups+u"
                    color="warn"
                    (click)="onRevokePermision(group)"
                  >
                    <span class="material-symbols-outlined"><mat-icon>block</mat-icon></span>
                  </a>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef>Nombre</th>
              <td mat-cell *matCellDef="let group">
                {{ group.name }}
              </td>
            </ng-container>
            <ng-container matColumnDef="Privilegios">
              <th mat-header-cell *matHeaderCellDef>Privilegios</th>
              <td mat-cell *matCellDef="let group">
                @if (group.create) {
                  <label for="create-action">create-</label>
                }
                @if (group.update) {
                  <label for="update-action">update-</label>
                }
                @if (group.delete) {
                  <label for="delete-action">delete-</label>
                }
                @if (group.read) {
                  <label for="read-action">read</label>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="permisos">
              <th mat-header-cell *matHeaderCellDef>#Permisos</th>
              <td mat-cell *matCellDef="let group">
                {{ group.permisions.length }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: showColumns" class="highlight-row"></tr>
          </table>
        </div>
      </section>
    </div>
    <pagination-controls
      (pageChange)="fetchGroups($event)"
      previousLabel="Anterior"
      nextLabel="Siguiente"
      id="server"
    ></pagination-controls>
  </div>
</div>
